import type { FaireProductEntity } from "../../entity_types/product";

export const p_85jt77d2xa: FaireProductEntity = {
  token: "p_85jt77d2xa",
  type: "product",
  name: "Joshua Tree California Bandana - 100% Cotton",
  brandToken: "b_c251hgcw2g",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e69bb0ac26053abc5b2c6958af4be9818cbf0952ffbf47aaf451431a9977222b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f13bcfc494d022b540893965cdc89bf42997b21db3f6c5b783be4d80b773d95.jpeg",
    "https://cdn.faire.com/fastly/8186702c78f2eb9e0c92178c2d2ce68877d0f3babde9882a19ea1614d8eb0b31.jpeg",
    "https://cdn.faire.com/fastly/3845d34ba70a879051bef4a62889e94d94fc8ad1e9b183ba8ce85ceb62b8fe26.jpeg",
    "https://cdn.faire.com/fastly/34498bd25895f22883c4a5668c591db39ddc9371652d832cf56fe0f4614a3f91.jpeg",
    "https://cdn.faire.com/fastly/8d8e802d33f27126eca186ef37f05074e9237fdd0ed1a3587e0d7a110470808e.jpeg",
    "https://cdn.faire.com/fastly/d083434317bd47064f619e81cf8b29fde02e0a147f0eec26f5d37bae9031dbbd.jpeg",
  ],
  priceDollars: 20.79,
  description:
    "Joshua Tree California Bandana\n\nVintage Desert Moon Illustration | Designed & Printed in USA\n\nThis premium Joshua Tree California bandana features original, hand-illustrated artwork inspired by the desert night sky. Designed and printed in the USA, it blends bold southwestern graphics with a timeless western aesthetic—making it an easy add-on accessory with strong visual impact at retail.\n\nThe design showcases celestial moon imagery surrounded by Joshua tree branches and desert stars in warm golden yellow, burnt orange, and natural cream tones against a deep black background. The high-contrast palette and bold border typography ensure standout merchandising whether folded, hung, or displayed flat.\n\n\n\n\n\n\n- - - - \nJoshua Tree bandana, California souvenir, national park accessory, western bandana, southwestern style bandana, made in USA bandana, desert gift item, boutique accessory",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:53.094Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
